'use es6';

export var getEmail = function getEmail(state) {
  return state.contact.email;
};